import React from "react";
import { Link } from "react-router-dom";

const LINKS = [
  { name: "Home", href: "/" },
  { name: "Learn More", href: "/learn-more" },
  { name: "Catalogue", href: "/catalogue" },
  { name: "Contact Us", href: "/connectus" },
  { name: "Unit Locations", href: "/locations" },
];

export default function FooterLinks() {
  return (
    <section className="relative bg-cream-100/60 text-maroon-800 border-t border-gold-500/40 pt-10 pb-10" id="additional-links">
      <div className="relative max-w-6xl mx-auto px-4">
        <ul className="flex flex-wrap justify-center gap-x-10 gap-y-3 font-accent font-medium text-base tracking-wide">
          {LINKS.map((link) => (
            <li key={link.href}>
              <Link to={link.href} className="hover:text-gold-700 transition-colors">
                {link.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
